/**
 * Mappt Registrierungs-Fehlercodes der API auf nutzerfreundliche Texte.
 * Meldungen kommen als "CODE" oder "CODE:detail" — das Detail ist z.B. die
 * maskierte E-Mail des Kontos, dem die Kundennummer bereits zugeordnet ist.
 */
const GENERIC = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.';

const ERROR_TEXT: Record<string, string> = {
  CUSTOMER_ALREADY_REGISTERED:
    'Für diese Kundennummer besteht bereits ein Zugang. Bitte melden Sie sich mit dem ' +
    'bestehenden Konto an oder nutzen Sie „Passwort vergessen“.',
  CUSTOMER_NOT_FOUND: 'Diese Kundennummer wurde nicht gefunden.',
  NO_EMAIL_ON_FILE:
    'Zu dieser Kundennummer ist keine E-Mail hinterlegt. Bitte kontaktieren Sie den Support.',
  EMAIL_ALREADY_REGISTERED:
    'Für diese E-Mail-Adresse existiert bereits ein Konto. Bitte melden Sie sich an ' +
    'oder nutzen Sie „Passwort vergessen“.',
  EMAIL_ALREADY_ASSIGNED:
    'Diese E-Mail-Adresse ist der Kundennummer bereits zugeordnet. Bitte melden Sie ' +
    'sich mit diesem Konto an oder wählen Sie eine andere Adresse.',
  INVALID_OR_EXPIRED: 'Dieser Bestätigungslink ist ungültig oder abgelaufen.',
};

export function mapRegistrationError(msg?: string): string {
  if (!msg) return GENERIC;
  const sep = msg.indexOf(':');
  const code = sep === -1 ? msg : msg.slice(0, sep);
  const detail = sep === -1 ? '' : msg.slice(sep + 1);
  if (code === 'CUSTOMER_ALREADY_REGISTERED' && detail) {
    return (
      `Für diese Kundennummer besteht bereits ein Zugang mit der E-Mail ${detail}. ` +
      'Bitte melden Sie sich mit diesem Konto an oder nutzen Sie „Passwort vergessen“. ' +
      'Sind Sie bereits mit diesem Konto angemeldet, melden Sie sich bitte einmal ab und wieder an.'
    );
  }
  return ERROR_TEXT[code] || GENERIC;
}
